import {
	mdiBattery,
	mdiBattery10,
	mdiBattery20,
	mdiBattery30,
	mdiBattery40,
	mdiBattery50,
	mdiBattery60,
	mdiBattery70,
	mdiBattery80,
	mdiBattery90,
	mdiBatteryCharging,
	mdiBatteryCharging10,
	mdiBatteryCharging20,
	mdiBatteryCharging30,
	mdiBatteryCharging40,
	mdiBatteryCharging50,
	mdiBatteryCharging60,
	mdiBatteryCharging70,
	mdiBatteryCharging80,
	mdiBatteryCharging90,
	mdiBatteryChargingOutline,
	mdiBatteryOutline,
} from "@mdi/js";
import { BaseColor } from "@soft-db/ui";
import { LiveStatus } from "./live-status";

const batteryIcons = [
	mdiBatteryOutline,
	mdiBattery10,
	mdiBattery20,
	mdiBattery30,
	mdiBattery40,
	mdiBattery50,
	mdiBattery60,
	mdiBattery70,
	mdiBattery80,
	mdiBattery90,
	mdiBattery,
];
const batteryChargingIcons = [
	mdiBatteryChargingOutline,
	mdiBatteryCharging10,
	mdiBatteryCharging20,
	mdiBatteryCharging30,
	mdiBatteryCharging40,
	mdiBatteryCharging50,
	mdiBatteryCharging60,
	mdiBatteryCharging70,
	mdiBatteryCharging80,
	mdiBatteryCharging90,
	mdiBatteryCharging,
];

export type BatteryBadge = {
	icon: string;
	color: BaseColor;
	value: string;
};

export function useBatteryBadge(
	status: MaybeRefOrGetter<LiveStatus | null>
): ComputedRef<BatteryBadge | null> {
	return computed(() => {
		const statusVal = toValue(status);
		if (statusVal == null) {
			return null;
		}

		let idx: number;

		const { battery, charging } = statusVal;
		if (battery == null || battery === 0) {
			return null;
		}

		if (battery <= 5) {
			idx = 0;
		} else if (battery >= 95) {
			idx = 10;
		} else {
			idx = Math.floor(battery / 10);
		}

		let icon: string;

		if (toValue(charging)) {
			icon = batteryChargingIcons[idx];
		} else {
			icon = batteryIcons[idx];
		}

		let color: BaseColor;
		if (battery > 50) {
			color = "success";
		} else if (battery > 20) {
			color = "warning";
		} else {
			color = "error";
		}

		return { value: battery.toFixed(0), icon, color };
	});
}
